import script from "./NavigationBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationBar.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationBar.vue?vue&type=style&index=0&id=3164dfaa&lang=css"

const __exports__ = script;

export default __exports__